import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=2cf7e89b"
import script from "./ResetPassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResetPassword.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=2cf7e89b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports